/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TranslatedStructureProperties } from '../model/models';
import { Translations } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TranslationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get All Translations
     * Returns all translations from the database.
     */
    getAllTranslations(extraHttpRequestParams?: any): Observable<Array<Translations>>;

    /**
     * Get Translated Structure Properties
     * Returns translations of structure properties for a bridge.
     * @param structureId ID of the structure to return translations for
     * @param fieldname Name of the field to be translated
     */
    getTranslatedStructureProperties(structureId: number, fieldname: string, extraHttpRequestParams?: any): Observable<Array<TranslatedStructureProperties>>;

}
